
import moment from 'moment';

export default class StoreDateSelectorController {

    constructor ($state, $attrs, User, $timeout) {
        this.$state = $state;
        this.$timeout = $timeout;
        this.isWorker = User.isWorker();
        this.searchStoreAutocomplete = false;
        this.selectedStoreResults = [];
        this.has = ($attrs.has || 'stores&month')
                        .split('&')
                        .reduce((res, value) => {
                            res[value] = true;
                            return res;
                        }, {});
    }

    changeFilters (input) {

        let startDate = undefined;
        let endDate = undefined;

        if (this.has.month) {
            startDate = moment(this.startDate).startOf('week').subtract(1, 'w').format('YYYY-MM-DD');
            endDate = moment(this.endDate).endOf('week').subtract(1, 'w').format('YYYY-MM-DD');
        }

        if (this.has.date) {
            startDate = moment(this.startDate).format('YYYY-MM-DD');
            endDate = moment(this.endDate).format('YYYY-MM-DD');
        }

        if (startDate && endDate) {
            if (
                    moment(startDate).add(3, 'months').isBefore(moment(endDate))
                ||  moment(startDate).isAfter(moment(endDate))
            ) {
                if (input == 'start') {
                    endDate = moment(startDate).add(3, 'months').subtract(1, 'days').format('YYYY-MM-DD');
                }
                if (input == 'end') {
                    startDate = moment(endDate).subtract(3, 'months').add(1, 'days').format('YYYY-MM-DD');
                }
            }
        }

        this.$state.transitionTo(this.state, {
            id:        (this.$state.params && this.$state.params.id) ? this.$state.params.id : undefined,
            stores:    (this.has.stores) ? this.selectedStore.id : undefined,
            startDate,
            endDate,
        }, { reload: true});
       
    }

    changeMonth (btnId) {

        if(btnId == "next"){
            this.startDate = moment(this.startDate).add(1, 'w').format('YYYY-MM-DD');
            this.endDate = moment(this.endDate).add(1, 'w').format('YYYY-MM-DD');
        }else if(btnId == "prev"){
            this.startDate = moment(this.startDate).subtract(1, 'w').format('YYYY-MM-DD');
            this.endDate = moment(this.endDate).subtract(1, 'w').format('YYYY-MM-DD');
        }

        this.changeFilters();
    }

    formatDate(date) {
        return moment(date).format('MMM-YYYY');
    }

    searchStore (search) {
        this.$timeout(() => {
            this.searchStoreAutocomplete = search != '';
            this.searchStoreResults = this.stores
                .filter(s => s.selectName.toLowerCase().indexOf(search.toLowerCase()) != -1)
                .slice(0, 5);
        }, 500);
    }

    selectStore (store) {
        this.selectedStore = store;
        this.changeFilters();
    }

}

StoreDateSelectorController.$inject = ['$state', '$attrs', 'User', '$timeout'];



// WEBPACK FOOTER //
// ./src/directive/store-date-selector/store-date-selector.controller.js